import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import LinkExtension from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect } from 'react';

import { ViewerBox } from './styles';

interface RichTextViewerProps {
  content: string;
}

export function RichTextViewer({ content }: RichTextViewerProps): JSX.Element {
  const editor = useEditor({
    editable: false,
    extensions: [
      StarterKit,
      TextStyle,
      Color,
      Underline,
      Highlight.configure({ multicolor: true }),
      TextAlign.configure({ types: ['paragraph'] }),
      LinkExtension.configure({ openOnClick: true }),
    ],
    content,
  });

  useEffect(() => {
    editor?.commands.setContent(content);
  }, [content, editor]);

  return (
    <ViewerBox>
      <EditorContent editor={editor} />
    </ViewerBox>
  );
}
